import { render } from "./Tcheacher.vue?vue&type=template&id=62bfb24c"
import script from "./Tcheacher.vue?vue&type=script&lang=js"
export * from "./Tcheacher.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\pc\\Documents\\projets\\school_app_front_novation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__